module.exports = __webpack_public_path__ + "img/e3.9e97a9b3.webp";